import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import Header from '../../components/Header';
import dayjs from 'dayjs';

const HourlyHeader = ({ isSmallScreen, children, selectedDate }) => {
    const theme = useTheme();
    const year = dayjs(selectedDate).year();

    return (
        <Box
            padding="1rem 1rem 0rem 1rem"
            marginBottom="1rem"
            backgroundColor={theme.palette.background.paper}
            borderRadius="15px"
            sx={{
                boxShadow: '8px 8px 20px rgba(0, 0, 0, 0.1)',
            }}
        >
            <Box display="flex" justifyContent="space-between" alignItems="flex-start" flexDirection={isSmallScreen ? 'column' : 'row'}>
                <Header title="HOURLY" subtitle="View your hourly counts of your devices" />
                <Typography variant="h2" color={theme.palette.text.white} fontWeight="bold" sx={{ alignSelf: isSmallScreen ? 'flex-end' : 'center', mt: isSmallScreen ? 1 : 0 }}>
                    {year}
                </Typography>
            </Box>

            <Box display="flex" flexDirection={isSmallScreen ? 'column' : 'row'} alignItems="center" gap={1} mt={2}>
                {children}
            </Box>
        </Box>
    );
};

export default HourlyHeader;
